import api from '../../../utils/api';
import { buildQuery } from '../../../utils/buildQuery';

export interface AdmissionLetterApplicant {
  applicantId: string;
  applicationNumber: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  email: string;
  phoneNumber: string;
  genderName: string;
  programName: string;
  programCode: string;
  programTypeName: string;
  modeOfStudyName: string;
  applicationBatchName: string;
  sessionName: string;
  countryName: string;
  stateName: string;
  createdDate: string;
  isAdmitted: string | null;
  matricNumber: string | null;
  [key: string]: any;
}

interface ApplicantsFilterRawResponse {
  message?: string;
  data?: {
    data?: AdmissionLetterApplicant[];
    totalCount?: number;
  };
}

export const getApplicantByApplicationNumber = async (
  applicationNumber: string,
): Promise<AdmissionLetterApplicant | null> => {
  const url = buildQuery({ ApplicationNumber: applicationNumber, PageNumber: 1, PageSize: 1 });
  const response = await api.get(`/Authorization/GetApplicantsFilter${url}`);
  const raw = response?.data as ApplicantsFilterRawResponse;
  return raw?.data?.data?.[0] ?? null;
};

export const printAdmissionLetter = async (applicationNumber: string): Promise<Blob> => {
  const url = buildQuery({ applicationNumber });
  return (await api.get(`/ReadMore/admin/admission-letter${url}`, { responseType: 'blob' }))
    ?.data as Blob;
};
